import React, { useState } from 'react';
import styled from 'styled-components';
import { withRouter } from 'library/util/core-router';
import { object, func, array } from 'prop-types';
import createDeterminerMutation from 'apps/admin/pages/persona-determiners/queries/create-determiner-mutation';
import updateDeterminerMutation from 'apps/admin/pages/persona-determiners/queries/update-determiner-mutation';
import hasHoc from 'util/hoc/has-hoc';
import OutcomeAttacher from 'apps/admin/pages/persona-determiners/personas/outcome-attacher';
import { attachOutcomeToPersona } from 'apps/admin/pages/persona-determiners/queries/persona-mutations';
import { resolve } from 'library/helpers/path-resolver';
import Notification, { Error as NotificationError, Success } from 'library/components/notification';

const StyledForm = styled.div`
  margin: 4em;
`;

const DeterminerForm = ({outcomes = [], determiner = {}, personas, reloadParentGraph, ...props}) => {
  const determinerFormObject = {...determiner, persona_id: determiner.persona ? determiner.persona.id: null};
  const [ values, setValues ] = useState(determinerFormObject);
  const persona = personas.find((persona) => persona.id == values.persona_id);

  const handleChange = (event) => {
    const { target: {name, value} } = event;
    setValues(values => ({ ...values, [name]: value }));
  };

  const handleSubmit = async () => {
    const submitDeterminer = (values) => {
      if (determiner.id) {
        return updateDeterminerMutation(values);
      } else {
        return createDeterminerMutation(values);
      }
    };

    try {
      const { data } = await submitDeterminer(values);
      const response = data?.submit_determiner;

      if (response?.success) {
        notifySuccess('Determiner submitted successfully');
        reloadParentGraph();
        props.history.push('/admin/persona-determiners');
      } else {
        notifyError(response?.errors?.join(', '));
      }
    } catch (e) {
      console.error(e);
      notifyError('Something went wrong, please try again.');
    }
  };

  const notifySuccess = (successMessage) => {
    Notification.new(
      { timeout: 5000 },
      <Success>
        { successMessage }
      </Success>
    );
  };

  const notifyError = (errorMessage) => {
    Notification.new(
      { timeout: 5000 },
      <NotificationError>
        { errorMessage }
      </NotificationError>
    );
  };

  const mapPersonaOptions = (persona, i) => (
    <option key={i} value={persona.id} selected={persona.id == values.persona_id}>
      {persona.name}
    </option>
  );

  return (
    <StyledForm>
      <h1>
        { determiner.uuid ? `Determiner UUID: ${determiner.uuid}` : 'New Determiner' }
      </h1>

      <label>
        Title
        <input name='title' label="Title" value={values.title} onChange={handleChange} />
      </label>

      <label>
        Logic String
        <textarea rows="10" name='logic_string' label="Logic String" value={values.logic_string} onChange={handleChange} />
      </label>

      <label>
        Persona
        <select name='persona_id' value={values.persona_id} onChange={handleChange}>
          <option hidden disabled selected value="">Select a persona</option>
          {personas && personas.map(mapPersonaOptions)}
        </select>
      </label>

      {persona && (
        <OutcomeAttacher callback={reloadParentGraph} handleSubmit={attachOutcomeToPersona} persona={persona} outcomes={outcomes} />
      )}
      <button onClick={handleSubmit}>Submit</button>
    </StyledForm>
  );
};

DeterminerForm.propTypes = {
  determiner: object,
  reloadParentGraph: func,
  personas: array,
  outcomes: array
};

DeterminerForm.hoc_list = [withRouter, 'withReloadParent'];

export default hasHoc(DeterminerForm);
